import {
  CardType as ServerCardType,
  PaymentMethodType as ServerPaymentMethodType,
} from '@yoop/server-model/payment';
import { CardType, PaymentMethodType } from '@yoop/whitelabel-data';

export const serverPaymentTypeFrom = (type: PaymentMethodType | CardType) => {
  switch (type) {
    case CardType.Mastercard:
      return ServerCardType.MASTERCARD;
    case CardType.Unknown:
      return ServerCardType.UNKNOWN;
    case CardType.Visa:
      return ServerCardType.VISA;
    case CardType.Amex:
      return ServerCardType.AMEX;
    case PaymentMethodType.Wechat:
      return ServerPaymentMethodType.WECHATPAY;
    case PaymentMethodType.Alipay:
      return ServerPaymentMethodType.ALIPAY;
    case PaymentMethodType.Klarna:
      return ServerPaymentMethodType.STRIPE_KLARNA;
    case PaymentMethodType.SquarePOS:
      return ServerPaymentMethodType.PHYSICAL_POS_SQUARE;
    default:
      return ServerPaymentMethodType.CASH;
  }
};

export const paymentMethodFrom = (serverMethod: ServerPaymentMethodType) => {
  switch (serverMethod) {
    case ServerPaymentMethodType.CREDIT_CARD:
      return PaymentMethodType.CreditCard;
    case ServerPaymentMethodType.CASH:
      return PaymentMethodType.Cash;
    case ServerPaymentMethodType.STRIPE_KLARNA:
      return PaymentMethodType.Klarna;
    case ServerPaymentMethodType.ALIPAY:
      return PaymentMethodType.Alipay;
    case ServerPaymentMethodType.WECHATPAY:
      return PaymentMethodType.Wechat;
    case ServerPaymentMethodType.PHYSICAL_POS_SQUARE:
      return PaymentMethodType.SquarePOS;
    default:
      return undefined;
  }
};

export const creditCardFrom = (serverCard: ServerCardType) => {
  switch (serverCard) {
    case ServerCardType.VISA:
      return CardType.Visa;
    case ServerCardType.MASTERCARD:
      return CardType.Mastercard;
    case ServerCardType.AMEX:
      return CardType.Amex;
    default:
      return CardType.Unknown;
  }
};
